import BasePagination from './BasePagination.vue';
import PaginationButton from './PaginationButton.vue';

export { BasePagination, PaginationButton };
